export default "__VITE_ASSET__0085abd8__"